
const storageKey = 'StREAM_DARK_MODE_ENABLED'
export class ThemeAppearanceUtils {
  static setDarkThemePreference (isDark) {
    localStorage.setItem(storageKey, `${isDark ? 1 : 0}`)
  }

  static getDefaultDarkThemePreference () {
    const r = localStorage.getItem(storageKey)
    if (!r || isNaN(+r)) {
      return false
    }
    return +r
  }
}



// WEBPACK FOOTER //
// ./src/utils/theme-appearance-utils.js